import { buildingsByRecipeId } from "../../../../balancing/types/buildingsByRecipeId";
import { createPathSelectBuildingInBuildMenu } from "../../../path/createPathSelectBuildingInBuildMenu";
export var pathSelectBuildingInBuildMenuUseHumus = function (action, state$, deps) {
    return createPathSelectBuildingInBuildMenu(function () {
        var recipeId = parseInt(action.taskType.recipeIds, 10);
        return buildingsByRecipeId.get(recipeId)[0];
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/use-humus/paths/pathSelectBuildingInBuildMenuUseHumus.ts
// module id = 2396
// module chunks = 3